var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIxLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ix-loading",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    className: "ix-loading",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .ix-leg{fill:#00BB80;}\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ix-leg",
    d: "M189.26,135.54c10.8-9.91,18.11-23.64,20.58-38.66c0.56-3.43-0.35-6.93-2.51-9.61     c-2.19-2.72-5.41-4.28-8.84-4.28c-5.46,0-10.2,4-11.27,9.52c-1.7,8.78-6.19,17.47-12.3,23.85c-4.89,5.09-13.18,11.16-24.92,11.16     c-11.65,0-19.95-6.14-24.85-11.3c-6.1-6.41-10.6-15.07-12.34-23.76c-1.1-5.49-5.84-9.47-11.26-9.47h-0.04     c-3.42,0-6.64,1.56-8.84,4.28c-2.16,2.67-3.07,6.17-2.51,9.61c2.47,15.02,9.78,28.75,20.58,38.66c0,0,12.76,14.46,39.23,14.46     S189.26,135.54,189.26,135.54z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    id: "t01",
    attributeType: "XML",
    attributeName: "transform",
    type: "rotate",
    from: "0 150 83",
    to: "360 150 83",
    dur: "0.3s",
    begin: "0s;t01.end+.3s"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ix-leg",
    d: "M110.74,150.46c-10.8,9.91-18.11,23.64-20.58,38.66c-0.56,3.43,0.35,6.93,2.51,9.61     c2.19,2.72,5.41,4.28,8.84,4.28c5.46,0,10.2-4,11.27-9.52c1.7-8.78,6.19-17.47,12.3-23.85c4.89-5.09,13.18-11.16,24.92-11.16     c11.65,0,19.95,6.14,24.85,11.3c6.1,6.41,10.6,15.07,12.34,23.76c1.1,5.49,5.84,9.47,11.26,9.47h0.04c3.42,0,6.64-1.56,8.84-4.28     c2.16-2.67,3.07-6.17,2.51-9.61c-2.47-15.02-9.78-28.75-20.58-38.66c0,0-12.76-14.46-39.23-14.46S110.74,150.46,110.74,150.46z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    id: "t02",
    attributeType: "XML",
    attributeName: "transform",
    type: "rotate",
    from: "0 150 203",
    to: "360 150 203",
    dur: "0.3s",
    begin: "0s;t02.end+.3s"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIxLoading);
export default __webpack_public_path__ + "static/media/ix-loading.448bef8bbe980db41ac2667a2a38e38f.svg";
export { ForwardRef as ReactComponent };